














import { filterMixin } from '@/utils/mixins/filterMixin'
import FlatFilter from '~/components/FlatFilter.vue'
import RangeDatePicker from '~/components/RangeDatePicker.vue'
import { DatePicker } from '~/utils/interfaces'

export default filterMixin.extend({
  components: {
    FlatFilter,
    RangeDatePicker,
  },
  data() {
    return {
      invoiceTypes: ['AGENCY', 'CLIENT'].map(type => ({
        text: this.$t(type),
        value: type,
      })),
    }
  },
  methods: {
    newFilter() {
      const dates = (this.$refs.datePicker as DatePicker).getData()
      this.filter.created_at__gte = dates.minDate
      this.filter.created_at__lte = dates.maxDate

      console.log(this.filter)

      this.$emit('filter', this.filter)
    },
  },
})
